import { tg } from '@infotech-soe/metaschema';

import { TCommandResult } from '../types';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import RunActionCommandImpl from './RunActionCommandImpl';

class PivotReportCommandImpl extends RunActionCommandImpl {
  public async execute(): Promise<TCommandResult> {
    return {
      actionType: this.actionSchema.Type,
    };
  }

  public getUserInteractor(): UserInteractor {
    if (tg.isActionWithForm(this.actionSchema)) {
      return {
        type: UserInteractorType.DEFAULT_FORM,
        category: this.category,
        action: this.action,
      };
    }
    return { type: UserInteractorType.PIVOT_REPORT };
  }
}

export default PivotReportCommandImpl;
